import { NumberKMPipe } from './../../../../../pipes/numberKMPipe';
import { Component, OnInit } from '@angular/core';
import { IndicatorsSearchToolbarModel } from '../../../../../models/indicators-search-toolbar-model.model';
import { IndicatorBoxModel } from '../../../../../models/indicator-box.model';
import { LoyaltyChart } from '../../../../../models/loyalty-chart-config.model';
import { QFilterModel } from '../../../../../models/qfilter.model';
import { IndicatorsChartService, IndicatorsService } from '../../../../../services/indicators/indicators.service';
import { AnalyticsService } from '../../../../../services/analytics/analytics.service';
import { CustomerCampaignService } from '../../../../../services/customer/customer-campaign.service';
import { TranslateService } from '@ngx-translate/core';
import { SearchToolbarModelFactoryService } from '../../../../../services/search-toolbar-model-factory/search-toolbar-model-factory.service';
import { SearchToolbarDateFunction, SearchToolbarFactoryParameters, SearchToolbarFilterGrouping, SearchToolbarFilterWindow, SearchToolbarSection } from '../../../../../models/search-toolbar-factory-parameters.model';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-promo-customer-value',
  templateUrl: './promo-value.component.html',
  styleUrls: ['./promo-value.component.css']
})
// Pagina 54
export class PromoValueComponent implements OnInit {
  show_results = false;

  public searchModel: IndicatorsSearchToolbarModel = new IndicatorsSearchToolbarModel();
  public indicators: IndicatorBoxModel[] = [];
  public translations: any;
  public promoError = false;
  public selectOneError: string;
  public data: QFilterModel;
  averageDiscountPerSegmentChart: LoyaltyChart;
  promoUsersPerSegmentChart: LoyaltyChart;
  associatedExpenditurePerSegmentChart: LoyaltyChart;
  redemptionPerSegmentChart: LoyaltyChart;

  constructor(
    private indicatorService: IndicatorsService,
    private chartsService: IndicatorsChartService,
    private svcAnalytics: AnalyticsService,
    private srvCustomerCampaign: CustomerCampaignService,
    private translate: TranslateService,
    private searchModelFactory: SearchToolbarModelFactoryService,
  ) {

  }

  ngOnInit() {

    this.translate.get([
      'promo.averageDiscountPerSegment',
      'promo.promoUsersPerSegment',
      'promo.associatedExpenditurePerSegment',
      'promo.redemptionPerSegment'
    ]).subscribe((t) => {
      this.translations = {
        averageDiscountPerSegment: t['promo.averageDiscountPerSegment'],
        promoUsersPerSegment: t['promo.promoUsersPerSegment'],
        associatedExpenditurePerSegment: t['promo.associatedExpenditurePerSegment'],
        redemptionPerSegment: t['promo.redemptionPerSegment']
      };
      this.initCharts();
    });

    this.translate.get('promo.selectOneErrorMsg').subscribe(msg => { this.selectOneError = msg; });


  }

  initCharts() {
    this.averageDiscountPerSegmentChart = new LoyaltyChart('line');
    this.averageDiscountPerSegmentChart.options.xAxis.title.text = this.translations.trendAndExpense;
    this.averageDiscountPerSegmentChart.options.xAxis.labels.formatter = function() {
      if (typeof this.value === 'string') {
        return this.value.split('-').reverse().join('/');
      }
      return this.value;
    };
    this.averageDiscountPerSegmentChart.options.yAxis.labels.formatter = function() {
      return this.value;
    };
    this.averageDiscountPerSegmentChart.options.tooltip = {formatter: function () {
        return this.key + ': ' + this.y;
      }};
    this.averageDiscountPerSegmentChart.options.chart.zoomType = 'xy';



    this.promoUsersPerSegmentChart = new LoyaltyChart('line');
    this.promoUsersPerSegmentChart.options.chart = {polar: true, type: 'line'};
    this.promoUsersPerSegmentChart.options.legend.enabled = false;
    this.promoUsersPerSegmentChart.options.yAxis.gridLineInterpolation = 'polygon';
    this.promoUsersPerSegmentChart.options.yAxis.lineWidth = 0;
    this.promoUsersPerSegmentChart.options.yAxis.min = 0;
    this.promoUsersPerSegmentChart.options.yAxis.labels.formatter = function() {
      return this.value + '%';
    };
    this.promoUsersPerSegmentChart.options.tooltip = {formatter: function () {
        return this.key + ': ' + this.y + '%';
      }};



    this.associatedExpenditurePerSegmentChart = new LoyaltyChart('line');
    this.associatedExpenditurePerSegmentChart.options.xAxis.title.text = this.translations.trendAndExpense;
    this.associatedExpenditurePerSegmentChart.options.xAxis.labels.formatter = function() {
      if (typeof this.value === 'string') {
        return this.value.split('-').reverse().join('/');
      }
      return this.value;
    };
    this.associatedExpenditurePerSegmentChart.options.yAxis.labels.formatter = function() {
      return NumberKMPipe.formatDynamic(this.value, '€');
    };
    this.associatedExpenditurePerSegmentChart.options.tooltip = {
      formatter: function() {
        return NumberKMPipe.formatDynamic(this.y, '€');
      }
    };
    this.associatedExpenditurePerSegmentChart.options.chart.zoomType = 'xy';



    this.redemptionPerSegmentChart = new LoyaltyChart('line');
    this.redemptionPerSegmentChart.options.chart = {polar: true, type: 'line'};
    this.redemptionPerSegmentChart.options.legend.enabled = false;
    this.redemptionPerSegmentChart.options.yAxis.gridLineInterpolation = 'polygon';
    this.redemptionPerSegmentChart.options.yAxis.lineWidth = 0;
    this.redemptionPerSegmentChart.options.yAxis.min = 0;
    this.redemptionPerSegmentChart.options.yAxis.labels.formatter = function() {
      return this.value + '%';
    };
    this.redemptionPerSegmentChart.options.tooltip = {
      formatter: function () {
        return this.key + ': ' + this.y + '%';
      }};
  }

  setChartInstance(chart: LoyaltyChart, chartInstance) {
    chart.instance = chartInstance;
  }


  searchValue(data: QFilterModel) {

    this.data = data;

    if (data['promo'] != null) {

      this.indicators = [];


      this.indicatorService.indicatorCalculation('promos.Q242', this.data).subscribe(
        Q242 => {

          /*Q242*/
          this.indicators.push(new IndicatorBoxModel([Q242.find(r => r.name === 'totale_utilizzatori_promo')], {dynamic: true, decimal_value: 0, hide_prev_value: true}));
          /*Q243*/
          this.indicators.push(new IndicatorBoxModel([Q242.find(r => r.name === 'utilizzatori_promo_nuovi_clienti')], {dynamic: true, decimal_value: 0, hide_prev_value: true}));
          /*Q244*/
          this.indicators.push(new IndicatorBoxModel([Q242.find(r => r.name === 'totale_spesa_associata')], {dynamic: true, decimal_value: 2, hide_prev_value: true}));
          /*Q245*/
          this.indicators.push(new IndicatorBoxModel([Q242.find(r => r.name === 'spesa_associata_nuovi_clienti')], {dynamic: true, decimal_value: 2, hide_prev_value: true}));

        });

      this.show_results = true;
      this.averageDiscountPerSegmentChart.options.chart.height = 400;
      this.chartsService.loadChart(this.averageDiscountPerSegmentChart, 'promos.Q250', data, this.indicatorService, this.translate, true, LoyaltyChart.colors, '');
      this.polarChart (data, 'promos.Q251', this.promoUsersPerSegmentChart);
      this.associatedExpenditurePerSegmentChart.options.chart.height = 400;
      this.chartsService.loadChart(this.associatedExpenditurePerSegmentChart, 'promos.Q252', data, this.indicatorService, this.translate, true, LoyaltyChart.colors, '');
      this.polarChart (data, 'promos.Q253', this.redemptionPerSegmentChart);
    } else {
      this.data = null;
      this.promoError = true;
    }

  }

  public toogleErrorPromoDialog() {
    this.promoError = !this.promoError;
  }

  public polarChart (data, query, chart) {

    Observable.zip (
      this.indicatorService.getChart(query, data, false)
    ).subscribe( ([res]) => {

      let serie0 = res.series[0].serie;
      let serie1 = res.series[1].serie;
      let labels: Array<any> = [];
      let series: Array<any> = [];

      for (let i = 0; i < serie0.length; i++) {
        labels.push ( serie0[i] );
        series.push ( serie1[i] );
      }

      chart.options.xAxis = {categories: labels, tickmarkPlacement: 'on', lineWidth: 0};
      chart.options.series = [{data: series, pointPlacement: 'on'}];
      chart.options.chart.height = 400;

      chart.instance.addSeries(chart.options.series);
      chart.instance.update(chart.options);
      chart.instance.redraw();

    });

  }

  public get filterApplied(): boolean
  {
    return this.data != null;
  }

  resetData() {
    this.show_results = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/views/analytics/promo/customer/value/promo-value.component.ts